import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  personal: {},
  consultDetails: {},
  medicine: {},
  review: {},
};

const doctorUpdatesSlice = createSlice({
  name: 'doctorUpdates',
  initialState,
  reducers: {
    updatePersonal: (state, action) => {
      state.personal = action.payload;
    },
    updateConsultDetails: (state, action) => {
      state.consultDetails = action.payload;
    },
    updateMedicine: (state, action) => {
      state.medicine = action.payload;
    },
    updateReview: (state, action) => {
      state.review = action.payload;
    },
  },
});

export const { updatePersonal, updateConsultDetails, updateMedicine, updateReview } = doctorUpdatesSlice.actions;

export default doctorUpdatesSlice.reducer;
